import { Component, OnInit, Input, ChangeDetectionStrategy, Output, EventEmitter, Inject, LOCALE_ID, forwardRef, ElementRef, ChangeDetectorRef } from '@angular/core';
import { FormControl, NG_VALUE_ACCESSOR } from '@angular/forms';
import { fromEvent, of, Subscription } from 'rxjs';
import { BsLocaleService } from 'ngx-bootstrap/datepicker';
import { debounceTime, distinctUntilChanged, switchMap, tap } from 'rxjs/operators';

@Component({
  selector: 'app-datetime-picker',
  templateUrl: './datetime-picker.component.html',
  styleUrls: ['./datetime-picker.component.css'],
  changeDetection:ChangeDetectionStrategy.OnPush,
  providers:[
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => DatetimePickerComponent),
      multi: true
    }    
  ]
})
export class DatetimePickerComponent implements OnInit {
  @Input() showDatePicker:boolean = true;
  @Input() showTimePicker:boolean = true;
  _datetime:number;
  @Input() set datetime(v:number) {
    if (this._datetime === v) return;
    this._datetime = v;

  }
  get datetime (){
    return this._datetime;
  }
  @Output() datetimeChange = new EventEmitter();
  @Input('ctrl') datetimeCtrl:FormControl; // formcontrol with Date type value


  dateCtrl:FormControl;
  timeCtrl:FormControl;

  @Output() onCalendarShown = new EventEmitter();
  @Output() onCalendarHidden = new EventEmitter();
  
  @Input() placeholder:string;
  
  
  @Input() maxDate:Date;
  @Input() minDate:Date;
  
  protected subscriptions = new Subscription();
  constructor(
    private localeService:BsLocaleService,
    private elementRef: ElementRef,
    private cdRef: ChangeDetectorRef,
    @Inject(LOCALE_ID) public localeId: string,    
  ) { 
    this.localeService.use(this.localeId);    
  }
  ngOnInit() {
    if (!this.datetimeCtrl) this.datetimeCtrl = new FormControl(this.datetime && new Date(this.datetime) || null);     
    this.maxDate = new Date(Date.now() + 365 * 24 * 60 * 60 * 1000);
    this.createControls();
    this.keepCtrlsInSync();
    this.datetimeCtrl.updateValueAndValidity();
  }

  ngAfterViewInit() {
    const timeFields = this.elementRef.nativeElement.querySelectorAll('.bs-timepicker-field');
    timeFields.forEach(field => {
      const keyup$ = fromEvent(field, 'keyup');
    
      this.subscriptions.add(keyup$.subscribe((e: {target: HTMLInputElement}) => {
        if (e.target.value === '' || isNaN(e.target.value as any)) {
          e.target.blur();
          return e.target.focus();
        }
  
        if (e.target.placeholder === 'HH') {
          let h = +e.target.value;
          h = h >= 24 ? 23 : h;
          e.target.value = h + '';
        } 
        if (e.target.placeholder === 'MM') {
          let m = +e.target.value;
          m = m >= 60 ? 59: m;
          e.target.value = m + '';
        }

        if (e.target.value.length === 2) {
          e.target.blur();
          return e.target.focus();
        }
      }));
    });
  }
  ngOnDestroy () {
    this.subscriptions.unsubscribe();
  }
  createControls () {
    this.dateCtrl = new FormControl(null);
    this.timeCtrl = new FormControl(null);
    this.updateDateAndTimeCtrlValues(this.datetimeCtrl.value);
  }
  private updateDateAndTimeCtrlValues (datetime:Date) {
    this.datetime = datetime && datetime.getTime();
    if ((this.dateCtrl.value && this.dateCtrl.value.toLocaleDateString()) !== (datetime && datetime.toLocaleDateString())) {
      const date_new = new Date(this.dateCtrl.value && this.dateCtrl.value.getTime());
      date_new.setFullYear(datetime.getFullYear(), datetime.getMonth(), datetime.getDate());
      this.dateCtrl.setValue(date_new);
    }
    if ((this.timeCtrl.value && this.timeCtrl.value.toLocaleTimeString()) !== (datetime && datetime.toLocaleTimeString())) {
      const time_new = new Date(this.timeCtrl.value && this.timeCtrl.value.getTime() || null);
      time_new.setHours(datetime.getHours(), datetime.getMinutes(), datetime.getSeconds(), datetime.getMilliseconds());
      this.timeCtrl.setValue(time_new);
    }
    this.datetimeChange.next(this.datetime);
  }
  keepCtrlsInSync () {
    this.subscriptions.add(
      this.datetimeCtrl.valueChanges.subscribe((v:Date)=>{
        if (this.datetime !== (v && v.getTime())) {
          this.updateDateAndTimeCtrlValues(v);
        }
      })
    );    
    this.subscriptions.add(
      this.dateCtrl.valueChanges.subscribe((v)=>{
        let date_old:Date = this.datetimeCtrl.value || new Date();
        const date_new:Date = v || null; 
        if (date_new) {
          date_old.setFullYear(date_new.getFullYear(), date_new.getMonth(), date_new.getDate());
          date_old.setSeconds(0);
          this.datetimeCtrl.setValue(date_old && new Date(date_old.getTime()) || null);
        }
        // else {
        //   date_old = null;
        // }
        // this.datetimeCtrl.setValue(date_old && new Date(date_old.getTime()) || null);
      })
    ) 
    this.subscriptions.add(
      this.timeCtrl.valueChanges.subscribe((v:Date)=>{
        let date_old:Date = this.datetimeCtrl.value || new Date();
        const date_new:Date = v || null; 
        if (date_new) {
          date_old.setHours(date_new.getHours(), date_new.getMinutes());
          date_old.setSeconds(0);
          this.datetimeCtrl.setValue(date_old && new Date(date_old.getTime()));
        } 
        // else {
        //   date_old = null;
        // }
        // this.datetimeCtrl.setValue(date_old && new Date(date_old.getTime()));
      })
    ) 
  } 
}
